import React from 'react';
import {
  Drawer,
  DrawerBody,
  DrawerHeader,
  DrawerOverlay,
  DrawerContent,
  DrawerCloseButton,
  Button,
  useDisclosure,
  VStack,
  HStack,
  
} from '@chakra-ui/react';
import { Link } from 'react-router-dom';
import { BiMenuAltLeft } from 'react-icons/bi';

const Header = () => {
  const { isOpen, onOpen, onClose } = useDisclosure();
  return (
    <>
      <Button
        zIndex={"overlay"}
        pos={'fixed'}
        top={'4'}
        left={'4'}
        colorScheme="blue"
        p={'0'}
        w={'10'}
        h={'10'}
        borderRadius={'full'}
        onClick={onOpen}
      >
        <BiMenuAltLeft size={'20'} />
      </Button>
      <Drawer isOpen={isOpen} placement="top" onClose={onClose}>
        <DrawerOverlay />

        <DrawerContent>
          <DrawerCloseButton />
          <DrawerHeader alignSelf={'center'} color={'black'} >
            LIBRARY {':)' }</DrawerHeader>
          <DrawerBody>
            <VStack alignItems={'flex'}>
              <Button
                onClick={onClose}
                variant={'ghost'}
                colorScheme={'blue'}
              >
                <Link to={'/'}>Home</Link>
              </Button>

              <Button
                onClick={onClose}
                variant={'ghost'}
                colorScheme={'blue'}
              >
                <Link to={'/videos'}>Videos</Link>
              </Button>

              <Button
                onClick={onClose}
                variant={'ghost'}
                colorScheme={'blue'}
              >
                <Link to={'/videos?category=free'}>Free videos</Link>
              </Button>

              <Button
                onClick={onClose}
                variant={'ghost'}
                colorScheme={'blue'}
              >
                <Link to={'/upload'}>Upload videos</Link>
              </Button>
            </VStack>

            <HStack
              to={'login'}
              pos={'absolute'}
              bottom={'10'}
              left={'0'}
      
              w={'full'}
              justifyContent={'space-between'}
            >
              <Button onClick={onClose} colorScheme={'blue'}>
                <Link to={'/login'}>Log In</Link>
              </Button>

              <Button
                onClick={onClose}
                colorScheme={'blue'}
                variant={'outline'}
                color={'purple'}
              >
                <Link to={'/Signup'}>Sign Up</Link>
              </Button>
            </HStack>
          </DrawerBody>
        </DrawerContent>
      </Drawer>
    </>
  );
};

export default Header;
